import React from 'react';

import { CreamCircleIcon } from '@zola/zola-ui';

import OpenedGift from 'assets/images/website/registryOnboard/OpenedGift';
import BrokenHeartComputer from 'assets/images/website/registryOnboard/BrokenHeartComputer';
import Robot from 'assets/images/website/registryOnboard/Robot';

import { RegistryAdvisor, GiftTracker, GiftPile1 } from '@zola/zola-ui/src/assets/images/icons';
import SectionContainer from '../SectionContainer/SectionContainer';

import styles from './WhyZolaRegistrySection.module.less';

const cardFieldContent = [
  {
    hed: 'One Store Curated For You Two',
    cards: [
      {
        type: 'disabled',
        dek: (
          <>
            <b>Other Registries</b> - Limited selection or literal retail wilderness. And good luck
            with returns!
          </>
        ),
        icon: OpenedGift,
      },
      {
        type: 'selected',
        dek: (
          <>
            <b>Zola Registry</b> - Everything couples want in one super-convenient place.
          </>
        ),
        icon: GiftPile1,
      },
    ],
  },
  {
    hed: 'Thoughtfully Designed for 2020',
    cards: [
      {
        type: 'disabled',
        dek: (
          <>
            <b>Other Registries</b> - Tough to set up, messy to manage, built in the age of dial up.
          </>
        ),
        icon: BrokenHeartComputer,
      },
      {
        type: 'selected',
        dek: (
          <>
            <b>Zola Registry</b> - Smart tools that simplify every step for you, down to writing
            thank yous.
          </>
        ),
        icon: GiftTracker,
      },
    ],
  },
  {
    hed: 'Support You Won’t Find Anywhere Else',
    cards: [
      {
        type: 'disabled',
        dek: (
          <>
            <b>Other Registries</b> - Bare-bones customer care.
          </>
        ),
        icon: Robot,
      },
      {
        type: 'selected',
        dek: (
          <>
            <b>Zola Registry</b> - Your own actually-human advisor who gets what it’s like to plan a
            wedding.
          </>
        ),
        icon: RegistryAdvisor,
      },
    ],
  },
];

const Card = ({ content }) => {
  const { icon, dek, type } = content;
  return (
    <div className={`${styles.card} ${styles[`card--${type}`]}`}>
      <CreamCircleIcon image={icon} />
      <p>{dek}</p>
    </div>
  );
};

const CardField = ({ key, content }) => {
  const { hed, cards } = content;
  return (
    <div className={styles.cardField}>
      <h3>{hed}</h3>
      <div className={styles.cards}>
        {cards.map((c, i) => (
          <Card key={`cardfield-${key}-${i}`} content={c} />
        ))}
      </div>
    </div>
  );
};

const WhyZolaRegistrySection = () => {
  return (
    <SectionContainer className={styles.sectionColor}>
      <h1 className={styles.heading}>Why Couples Choose Zola Registry (Over the Other Guys)</h1>
      {cardFieldContent.map((cf, i) => (
        <CardField key={i} content={cf} />
      ))}
    </SectionContainer>
  );
};

export default WhyZolaRegistrySection;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/WhyZolaRegistrySection/WhyZolaRegistrySection.jsx